var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),_c('HeroPage'),_c('AboutUs'),_c('WhyPage'),_c('CallToAction'),_c('FooterPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }